import type { BagelDocumentDetailTab } from 'features/bagel/utils/bagelDocumentDetailTab';
import { bagelDocumentDetailTabToHash } from 'features/bagel/utils/bagelDocumentDetailTab';

// auth
export const getLoginPath = () => '/';

/** Full URL for sharing a Rosie path (same origin; safe paths only). */
export { getRosieAbsoluteUrl } from './postLoginRedirect';
// rosie
export const getRosieUserListPath = () => '/admin/users';
export const getRosieUserDetailsPath = (id: string) =>
  `/admin/users/details/${id}`;
export const getRosieUserDetailsActivityPath = (id: string) =>
  `/admin/users/details/${id}/activity`;
export const getRosieUserDetailsPermissionsPath = (id: string) =>
  `/admin/users/details/${id}/permissions`;
export const getRosieUserDetailsMcpPath = (id: string) =>
  `/admin/users/details/${id}/mcp`;
export const getCreateRosieUserPath = () => '/admin/users/new';
export const getManageRolesPath = () => '/admin/manage-roles';
export const getManageRoleDetailPath = (key: string) =>
  `/admin/manage-roles/${encodeURIComponent(key)}`;
export const getCreateManageRolePath = () => '/admin/manage-roles/new';
export const getActivityLogPath = () => '/admin/activity-logs';
// my-txt profiles (Rosie TXTer / My TXT profile management UI)
export const getTxterListPath = () => '/my-txt/profiles';
export const getTxterDetailsPath = (id: string) =>
  `/my-txt/profile/${id}/profile`;
export const getTxterDetailsProfilePath = (id: string) =>
  `/my-txt/profile/${id}/profile`;
export const getTxterDetailsAccessPath = (id: string) =>
  `/my-txt/profile/${id}/access`;
export const getTxterDetailsProgramsPath = (id: string) =>
  `/my-txt/profile/${id}/programs`;
// scla
export const getSclaAppListPath = (
  page: number,
  limit: number,
  sortColumn: string,
  sortType: string,
  appStatus: string,
  year: string,
  school: string,
  search?: string,
) => {
  const schoolStr = encodeURIComponent(school);
  if (search) {
    return `/scla?page=${page}&limit=${limit}&sortColumn=${sortColumn}&sortType=${sortType}&search=${search}&appStatus=${appStatus}&year=${year}&school=${schoolStr}`;
  }

  return `/scla?page=${page}&limit=${limit}&sortColumn=${sortColumn}&sortType=${sortType}&search=&appStatus=${appStatus}&year=${year}&school=${schoolStr}`;
};

export const getSclaReadersPath = () => '/scla/readers';

export const getSclaReaderAppListPath = (
  page: number,
  limit: number,
  sortColumn: string,
  sortType: string,
  appStatus: string,
  year: string,
  school: string,
  search?: string,
) => {
  const schoolStr = encodeURIComponent(school);
  if (search) {
    return `/scla/readers/?page=${page}&limit=${limit}&sortColumn=${sortColumn}&sortType=${sortType}&search=${search}&appStatus=${appStatus}&year=${year}&school=${schoolStr}`;
  }

  return `/scla/readers/?page=${page}&limit=${limit}&sortColumn=${sortColumn}&sortType=${sortType}&search=&appStatus=${appStatus}&year=${year}&school=${schoolStr}`;
};

export const getSclaInterestListPath = (
  page: number,
  limit: number,
  sortColumn: string,
  sortType: string,
  year: string,
  school: string,
  search?: string,
) => {
  const schoolStr = encodeURIComponent(school);
  if (search) {
    return `/scla/interests?page=${page}&limit=${limit}&sortColumn=${sortColumn}&sortType=${sortType}&search=${search}&year=${year}&school=${schoolStr}`;
  }

  return `/scla/interests?page=${page}&limit=${limit}&sortColumn=${sortColumn}&sortType=${sortType}&search=&year=${year}&school=${schoolStr}`;
};

export const getSclaAppStatsPath = (year: string) =>
  `/scla/stats?year=${year}`;
export const getUploadSclaAppPdfPath = () => '/scla/upload-app-pdf';
export const getUploadSclaInterviewSheetPath = () =>
  '/scla/upload-interview-sheet';
export const getSclaCohortRosterPath = (year: string) =>
  `/scla/cohort-roster?page=1&limit=30&sortColumn=createdOn&sortType=desc&search=&appStatus=all&year=${year}&school=all&ethnicity=all&selectedForInterview=all`;
export const getSclaCohortFellowsPath = (year: string) =>
  `/scla/cohort-fellows?page=1&limit=30&sortColumn=name&sortType=asc&search=&year=${year}&status=all`;
export const getSclaCohortTeamBuilderPath = (year: string) =>
  `/scla/cohort-team-builder?year=${year}`;
export const getSclaCohortProgramPath = (year: string) =>
  `/scla/cohort-program?year=${year}`;
export const getSclaAttendancePath = (year: string) =>
  `/scla/attendance?page=1&limit=30&sortColumn=createdOn&sortType=desc&search=&year=${year}`;
export const getSclaChallengeCompletionPath = (year: string) =>
  `/scla/cohort-challenge-completion?year=${year}`;
// hackathon

// Volunteer stats
export const getHackathonVolunteerStatsPath = () =>
  '/hackathon/volunteer-stats';
// volunteer list
export const getHackathonVolunteerListPath = () =>
  '/hackathon/volunteer-list';

// Hackathon students stats
export const getHackathonStudentStatsPath = () =>
  '/hackathon/student-stats';

// student list
export const getHackathonStudentListPath = () => '/hackathon/student-list';

// seals
export const getSealsLegacyAppListPath = () => '/seals/legacy?year=2022';
export const getSealsAppListPath = () => '/seals';
export const getSealsAppStatsPath = () => '/seals/legacy/stats?year=2022';
// labs
export const getApprenticeAppListPath = () => '/labs';
export const getBusinessCardAppListPath = () => '/labs/business';
export const getBusinessCardAddPath = () => '/labs/business-cards';
// my-txt
export const getCreateMyTxtUserPath = () => '/admin/my-txt/users/new';

// emails
export const getEmailTemplateListPath = () => '/emails/templates';
export const getEmailTemplateDetailsPath = (id: string) =>
  `/emails/template/${id}`;
export const getCreateEmailTemplatePath = () => '/emails/templates/create';

// automated calls
export const getAutomatedCallsCallLogsPath = () =>
  '/automated-calls/call-logs';
export const getAutomatedCallsScriptManagementPath = () =>
  '/automated-calls/script-management';
export const getAutomatedCallsBatchCallsPath = () =>
  '/automated-calls/batch-calls';
export const getAutomatedCallsCreateBatchCallPath = () =>
  '/automated-calls/batch-calls/create';
export const getAutomatedCallsBatchCallDetailsPath = (batchId: string) =>
  `/automated-calls/batch-calls/${batchId}`;

// bitwarden
export const getBitwardenProjectsPath = () => '/admin/bitwarden/projects';
export const getDropboxAuditPath = () => '/admin/dropbox/audit';

// arcade games (student Phaser/Pygame games — build/publish + RetroPie cabinets)
export const getArcadeGamesPath = () => '/admin/arcade-games';

// SCLA mobile applications (scla-2026-mothership student apps)
export const getSclaMobileApplicationsPath = () => '/scla/mobile-applications';
export const getSclaMobileApplicationsPriceHistoryPath = () =>
  '/scla/mobile-applications/price-history';
export const getSclaMobileApplicationsStoresPath = () =>
  '/scla/mobile-applications/stores';
export const getSclaMobileApplicationsStorePath = (shopId: string) =>
  `/scla/mobile-applications/stores/${shopId}`;
export const getSclaMobileApplicationsJobsPath = () =>
  '/scla/mobile-applications/jobs';
export const getSclaMobileApplicationsDevicesPath = () =>
  '/scla/mobile-applications/devices';
export const getSclaMobileApplicationsEnrichmentJobsPath = () =>
  '/scla/mobile-applications/enrichment-jobs';
export const getSclaMobileApplicationsAiUsagePath = () =>
  '/scla/mobile-applications/ai-usage';
/** @deprecated Prefer getSclaMobileApplicationsPath */
export const getMothershipAdminPath = getSclaMobileApplicationsPath;

// surveys
export const getSurveysListPath = () => '/surveys';
export const getSurveyCreatePath = () => '/surveys/create';
export const getSurveyEditPath = (id: string) => `/surveys/${id}/edit`;
export const getAiWorkshopSurveyResultsPath = () =>
  '/surveys/ai-workshop/results';

// bagel ai
export const getBagelConfigPath = () => '/bagel/config';

export const getBagelDocumentViewPath = (
  id: string,
  tab: BagelDocumentDetailTab = 'details',
) => {
  const base = `/bagel/documents/${encodeURIComponent(id)}`;
  const hash = bagelDocumentDetailTabToHash(tab);
  return hash ? `${base}${hash}` : base;
};

// batch sms
export const getBatchSmsCampaignsPath = () => '/batch-sms';
export const getBatchSmsInboxPath = () => '/batch-sms/inbox';
export const getBatchSmsMessagesPath = () => '/batch-sms/messages';
export const getBatchSmsConversationsPath = () =>
  '/batch-sms/conversations';
export const getBatchSmsConversationPath = (phone: string) =>
  `/batch-sms/conversations/${encodeURIComponent(phone)}`;
export const getCreateBatchSmsCampaignPath = () => '/batch-sms/create';
export const getBatchSmsCampaignDetailsPath = (id: string) =>
  `/batch-sms/${id}`;

// txt merch
export const getTxtMerchPath = () => '/txt-merch';
export const getTxtMerchProductsPath = () => '/txt-merch/products';
export const getTxtMerchProductDetailPath = (id: string) =>
  `/txt-merch/products/${id}/details`;
export const getTxtMerchProductDetailTabPath = (
  id: string,
  tab: 'details' | 'gallery' | 'pricing',
) => `/txt-merch/products/${id}/${tab}`;
export const getTxtMerchMaterialsPath = () => '/txt-merch/materials';
export const getTxtMerchSalesPath = () => '/txt-merch/product-sales';
export const getTxtMerchExpensesPath = () => '/txt-merch/expenses';
export const getTxtMerchMaterialDetailPath = (materialId: string) =>
  `/txt-merch/materials/${materialId}`;

// txt programs (fee programs / workshops — admin payment links)
export const getTxtProgramsPath = () => '/txt-programs';
export const getTxtProgramRegistrationsPath = () =>
  '/txt-programs/registrations';
/** @deprecated Use getTxtProgramRegistrationsPath (same URL). */
export const getTxtProgramEnrollmentsPath = () =>
  '/txt-programs/registrations';
export const getTxtProgramEditPath = (
  id: string,
  tab?: 'info' | 'registration',
) => {
  const base = `/txt-programs/${id}/edit`;
  if (!tab || tab === 'info') return base;
  return `${base}?tab=${tab}`;
};
export const getTxtProgramOutlinePagesPath = () =>
  '/txt-programs/outline-pages';
export const getTxtProgramOutlinePagesNewPath = () =>
  '/txt-programs/outline-pages/new';
export const getTxtProgramOutlinePageEditPath = (id: string) =>
  `/txt-programs/outline-pages/${id}`;

// technology / equipment inventory
export const getEquipmentListPath = () => '/technology/equipment';

export const getEquipmentDetailsPath = (id: string) =>
  `/technology/equipment/${id}`;
export const getEquipmentDetailsGeneralPath = (id: string) =>
  `/technology/equipment/${id}`;
export const getEquipmentDetailsCheckoutPath = (id: string) =>
  `/technology/equipment/${id}`;

const EQUIPMENT_QR_BASE_URL = 'https://rosiev2.exploringtech.org';

/** Opens equipment details (general tab) and triggers checkout vs return modal via `?qr=1`. */
export const getEquipmentCheckoutQrUrl = (id: string) =>
  `${EQUIPMENT_QR_BASE_URL}${getEquipmentDetailsGeneralPath(id)}?qr=1`;
export const getEquipmentDetailsGalleryPath = (id: string) =>
  `/technology/equipment/${id}`;

export const getSignedFormsTemplatesPath = () => '/signed-forms/templates';
export const getSignedFormsCreateTemplatePath = () =>
  '/signed-forms/templates/create';
export const getSignedFormsTemplateDetailsPath = (id: string) =>
  `/signed-forms/templates/${id}`;
export const getSignedFormsAssignmentsPath = () =>
  '/signed-forms/assignments';
export const getSignedFormsAssignmentDetailsPath = (id: string) =>
  `/signed-forms/assignments/${id}`;
export const getFormRecipientsPath = () => '/signed-forms/assignments';

export const getStudentActivitiesPageListPath = () =>
  '/txt-learning/pages';
export const getStudentActivitiesPageCreatePath = () =>
  '/txt-learning/pages/create';
export const getStudentActivitiesPageDetailPath = (id: string) =>
  `/txt-learning/pages/${id}`;

export const getStudentActivitiesAssignmentsListPath = () =>
  '/txt-learning/assignments';
export const getStudentActivitiesAssignmentDetailPath = (id: string) =>
  `/txt-learning/assignments/${id}`;

export const getLabelPrintingPath = () => '/label-printing';
